import { hideAnnualReceiptBanner } from './headerTaxReceiptBanner';

export const addEventHandlersToHeaderElements = function () {
    $('.js-header-link-sign-in').on('click', window.toggleSignInOverlay);
    $('.js-header-link-greeting').on('click', toggleDonorAccountInfo);
    $('.js-hide-annual-receipt-banner').on('click', hideAnnualReceiptBanner);
    $('.js-hide-teacher-email-confirm-banner').on('click', hideTeacherEmailConfirmBanner);
    $('.js-hide-match-code').on('click', hideMatchCode);
    $('.js-hide-teacher-school-email-confirm-banner').on('click', hideTeacherSchoolEmailConfirmBanner);
    $('.js-hide-teacher-banner').on('click', hideTeacherBanner);
    $('.js-mobile-menu').on('click', toggleMenuLinks);
};

export function toggleDonorAccountInfo() {
    $('#mainHeader').toggleClass('stackup');
    if ($('#account-trigger').hasClass('disabled')) {
        return;
    }
    if (window.headerType === 'iframeHeader') return true;
    const visible = $('#user-account-links .subnav').is(':visible');
    window.hideAccountDropdowns();
    if (!visible) {
        $('#user-account-links .subnav').show();
        $('#account-trigger').addClass('triggered');
    }
    return window.returnFalse();
}

function hideTeacherEmailConfirmBanner() {
    $('#teacher-email-confirm-banner').hide();
    window.eraseCookie('teacherEmailConfirm');
}

function hideTeacherSchoolEmailConfirmBanner() {
    $('#teacher-school-email-confirm-banner').hide();
    window.eraseCookie('teacherSchoolEmailConfirm');
}

function hideMatchCode() {
    window.createCookie('xMatchCode', 'true', 365);
    $('.newbie-banner.match-code').hide();
}

function hideTeacherBanner() {
    window.createCookie('xTeacherBanner', 'true', 365);
    $('#teacher-banner').hide();
}

function toggleMenuLinks() {
    $('#main-header').slideToggle(300);
}

export const closeMenuLinks = function (duration?: number) {
    $('#main-header').slideUp(duration);
};

export const initHeaderElements = function () {
    if (document.getElementById('account-links')) {
        window.setUpUserCookies();
        window.personalizeHeaderElements();
    }
};
